<template>
<div class="flex">
  <img v-if="movie && movie.length !=0" :src="movie.response.cover" alt="" width="350">
    <vs-upload v-if="movie && movie.response" :action="`${this.$apiUrl}/movies/poster/${movie.response.id}`" fileName="cover"  limit="1" text="Cover Image" vs-tab="dfdf" :automatic="true" @on-success="successUpload" />

  
</div>

</template>

<script>
export default {
    props:['movie'],
  methods:{
    successUpload(){
      this.$vs.notify({color:'success',title:'Upload Success',text:''})
      setTimeout(() => {
        location.reload();  
      }, 1000);
      
    }
  }
}
</script>